"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MaintenanceIntervalType = void 0;
var MaintenanceIntervalType;
(function (MaintenanceIntervalType) {
    MaintenanceIntervalType["HourmeterReading"] = "hourmeter reading";
    MaintenanceIntervalType["OdometerReading"] = "odometer reading";
    MaintenanceIntervalType["NumberOfDays"] = "days";
})(MaintenanceIntervalType = exports.MaintenanceIntervalType || (exports.MaintenanceIntervalType = {}));
//# sourceMappingURL=maintenance.js.map